import * as d3 from "d3";

export const _isNaN = function (value) {
  var n = Number(value);
  return n !== n;
};

export const currencyFormatter = (params, Currency_Symbol) => {
  if (_isNaN(params.value)) return 0;
  return `${Currency_Symbol} ${d3.format(",")(Math.round(params.value))}`;
};

export const dateAndTimeFormatter = (params) => {
  return new Intl.DateTimeFormat("en-US", {
    timeZone: "UTC",
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour12: true,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(new Date(params.value));
};

export const dateFormatter = (params) => {
  if ([null, undefined, ""].includes(params.value)) {
    return "";
  } else {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "UTC",
      month: "numeric",
      day: "numeric",
      year: "numeric",
    }).format(new Date(params.value));
  }
};

export const percentageDFormatter = (params) => {
  if (!["", null, undefined].includes(params.value)) {
    return `${Math.round(params.value * 100)}%`;
  } else {
    return "";
  }
};

export const percFormatterv2 = (params) => {
  return params.value === "Outlier Opp."
    ? "Outlier Opp."
    : [null, undefined, ""].includes(params.value)
    ? "0%"
    : `${Math.round(params.value * 100)}%`;
};

export const newOppDisplayValue = {
  new: "New",
  new_resurrected: "Resurrected",
  new_resurrected_won_to_lost: "Resurrected Won to Lost",
  new_resurrected_won_to_won: "Resurrected Won to Won",
  new_resurrected_lost_to_lost: "Resurrected Lost to Lost",
  new_resurrected_lost_to_won: "Resurrected Lost to Won",
};

export const newOwpFormatter = (params) => {
  return newOppDisplayValue[params.value];
};
